import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from '@apollo/react-hooks'
import { initLoginFlow } from './initialization'

const startReact = async (apollo) => {
  ReactDOM.render((
    <React.StrictMode>
      <BrowserRouter>
        <ApolloProvider client={apollo}>
          <App />
        </ApolloProvider>
      </BrowserRouter>
    </React.StrictMode>
  ),
  document.getElementById('root'))
}

const index = async () => {
  const { apollo } = await initLoginFlow()
  await startReact(apollo)
}

index()
